module.exports = __webpack_public_path__ + "static/media/link-logo-ubs.c116ccd1.jpg";